import { Component, Vue } from 'vue-property-decorator'
import gsap from "gsap"

@Component
export default class TransitionMixins extends Vue {
  previewEnter(el: HTMLElement, done: () => void) {
    gsap.fromTo(
      el,
      0.3,
      { opacity: 1, xPercent: 100 },
      {
        opacity: 1,
        xPercent: 0,
        ease: "power2.easeOut",
        onComplete: done,
      }
    )
  }

  previewLeave(el: HTMLElement, done: () => void) {
    gsap.fromTo(
      el,
      0.3,
      { opacity: 1, xPercent: 0 },
      {
        opacity: 0,
        xPercent: 50,
        ease: "power2.easeOut",
        onComplete: done,
      }
    )
  }

  enter(el: HTMLElement, done: () => void) {
    gsap.fromTo(
      el,
      0.3,
      { opacity: 0, y: 40 },
      { opacity: 1, y: 0, onComplete: done },
    );
  }

  leave(el: HTMLElement, done: () => void) {
    gsap.to(el, 0.3, { opacity: 0, y: -40, onComplete: done });
  }
}